/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const statusTokens = {
  ContentFontColorBaseDefault: '#ffffff',
  ContentFontSizeBaseDefault: '1.35rem',
  ContentSpacingLeftBaseDefault: '12px',
  GraphicBackgroundColorInverseDefault: '#ffffff',
  GraphicBackgroundColorDashedDefault: '#ffffff',
  GraphicBackgroundColorBlueLightDefault: '#8babd6',
  GraphicBackgroundColorBlueLightestDefault: '#dfe8f4',
  GraphicBackgroundColorBlueDefault: '#2c67b5',
  GraphicBackgroundColorGrayDarkerDefault: '#656b6b',
  GraphicBackgroundColorGrayDefault: '#c4c4c4',
  GraphicBackgroundColorGreenLightestDefault: '#addfd9',
  GraphicBackgroundColorGreenDefault: '#32b0a0',
  GraphicBackgroundColorOrangeDefault: '#e57b5a',
  GraphicBackgroundColorPinkDefault: '#b1d636',
  GraphicBackgroundColorRedDefault: '#da1c3c',
  GraphicBackgroundColorSlateDefault: '#232b2b',
  GraphicBackgroundColorWhiteDefault: '#ffffff',
  GraphicBackgroundColorYellowDefault: '#f8d648',
  GraphicBackgroundColorPositiveDefault: '#32b0a0',
  GraphicBackgroundColorNoticeDefault: '#e57b5a',
  GraphicBackgroundColorNegativeDefault: '#da1c3c',
  GraphicBackgroundColorNeutralDefault: '#c4c4c4',
  GraphicBackgroundColorPendingDefault: '#f8d648',
  GraphicBorderRadiusBaseDefault: '50%',
  GraphicBorderWidthBaseDefault: '1px',
  GraphicBorderStyleInverseDefault: 'solid',
  GraphicBorderStyleDashedDefault: 'dashed',
  GraphicSizeBaseDefault: '38px',
  GraphicSizeMiniDefault: '8px',
} as const;
